<mat-card *ngIf="!loading" class="mcd-card standards-search-card">
  <mat-card-header class="search-results-header" style="padding: 10px 0">
    <mat-card-title class="search-results-title-row">
      <button type="button" class="search-back-btn" (click)="goBack()">
        <img src="/assets/images/back to list.svg" alt="" />
        Back
      </button>
      <span class="search-results-title">Search results for &quot;{{ query }}&quot;</span>
    </mat-card-title>
  </mat-card-header>

  <section class="search-tabs-row">
    <div
      *ngFor="let tab of searchTabs"
      class="tab-wrapper"
      [class.active]="activeSearchTab === tab.id"
      (click)="setActiveTab(tab.id)"
    >
      <span>
        <img [src]="tab.icon" height="16" width="16" alt="" />
      </span>
      <span class="tab-label">{{ tab.label }}</span>
    </div>
  </section>

  <mat-card-content class="mcd-card-content">
    <div class="search-filters-row">
      <!-- <app-standard-search-filter></app-standard-search-filter> -->
      <app-locations-filter
        *ngIf="activeSearchTab !== 'exceptions'"
        [isNrbes]="false"
        (messageEvent)="receivedFilteration($event)"
      ></app-locations-filter>
      <div style="flex: 1"></div>
      <button
        type="button"
        class="extract-button"
        *ngIf="activeSearchTab !== 'exceptions' && grses.length > 0"
        [disabled]="isDownloading"
        (click)="downloadExcel()"
      >
        <img src="/assets/images/export 1.svg" style="margin-right: 5px" />{{
        isDownloading ? "Exporting..." : "Export"
        }}
      </button>
    </div>

    <div class="table-wrapper" *ngIf="currentResultCount > 0">
      <table
        class="table nrbes-grid"
        matSort
        (matSortChange)="sortData($event)"
      >
        <thead class="thead-light">
          <tr>
            <th mat-sort-header="title" width="160" scope="col">
              <div class="title-cell-wrapper">
                <mat-checkbox
                  *ngIf="currentResultCount > 0"
                  color="primary"
                  [checked]="isAllOnPageSelected()"
                  [indeterminate]="isSomeOnPageSelected()"
                  (click)="$event.stopPropagation()"
                  (change)="selectAllOnPageChange($event)"
                ></mat-checkbox>
                <span>Title</span>
              </div>
            </th>
            <th scope="col" width="140">Type</th>
            <th mat-sort-header="category" scope="col" width="140">
              Category
            </th>
            <th scope="col" width="140">Location</th>
            <th mat-sort-header="desc" scope="col" width="30%">
              Description
            </th>
            <th scope="col" width="60"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of displayResults"
            (click)="
              item.__isException
                ? exceptionRowSelected(item)
                : rowSelected(item)
            "
          >
            <td
              class="title-cell"
              style="font-weight: 500; color: #3949a3; font-size: 14px"
            >
              <div class="title-cell-wrapper">
                <mat-checkbox
                  color="primary"
                  [checked]="isSelected(item.id)"
                  (click)="$event.stopPropagation()"
                  (change)="onCheckboxChange($event, item.id)"
                ></mat-checkbox>
                <span>{{
                  item.__isException ? item.standard?.title : item.title
                }}</span>
              </div>
            </td>
            <td class="type-cell">
              <ng-container *ngIf="!item.__isException; else exceptionType">
                <img
                  [src]="getStandardTypeIcon(item.standardTypeId)"
                  height="16"
                  width="16"
                  alt=""
                  style="margin-right: 6px; vertical-align: middle"
                />
              </ng-container>
              <ng-template #exceptionType>
                <img
                  src="/assets/images/todo 2.svg"
                  height="16"
                  width="16"
                  alt=""
                  style="margin-right: 6px; vertical-align: middle"
                />
              </ng-template>
            </td>
            <td class="category-cell">
              {{ item.__isException ? "-" : item.category?.name }}
            </td>
            <td class="location-cell">
              {{ item.__isException ? "-" : getLocationNames(item) }}
            </td>
            <td class="description">
              <span
                title="{{ item.__isException ? item.description : item.shortDescription }}"
                class="description"
              >
                {{ item.__isException ? item.description : item.shortDescription }}
              </span>
            </td>
            <td
              class="actions-cell"
              (click)="$event.stopPropagation()"
              *ngIf="!item.__isException; else exceptionActions"
            >
              <div class="grid-actions hide-sm" style="position: relative">
                <button
                  style="border: none; background: none; cursor: pointer"
                  (click)="togglePopup($event, item)"
                >
                  <img src="/assets/images/menu-dots 2.svg" />
                </button>

                <div
                  class="action-popup editDeletModal"
                  *ngIf="activePopupId === item.id"
                >
                  <div
                    style="padding: 8px; text-align: left; cursor: pointer"
                    class="onEditHover"
                    (click)="onEdit(item)"
                  >
                    <a
                      class="action-controls"
                      style="
                        text-decoration: none;
                        color: rgba(63, 81, 181, 1);
                        font-size: 14px;
                        text-align: left;
                        display: block;
                        width: 100%;
                      "
                      title="Edit"
                      href="javascript:void(0);"
                    >
                      <span
                        ><img
                          src="/assets/images/d-edit 1.svg"
                          style="margin-bottom: 4px; margin-right: 5px"
                      /></span>
                      <span>Edit</span>
                    </a>
                  </div>

                  <hr style="margin: 2px; border: 1px solid #dde1e6" />

                  <div
                    style="padding: 8px; text-align: left; cursor: pointer"
                    class="oDeleteHover"
                    (click)="openDeleteModal(item, $event)"
                  >
                    <a
                      class="action-controls"
                      style="
                        text-decoration: none;
                        color: rgba(222, 52, 40, 1);
                        font-size: 14px;
                        display: block;
                        width: 100%;
                      "
                      title="Delete"
                      href="javascript:void(0);"
                    >
                      <span
                        ><img
                          src="/assets/images/bin.svg"
                          style="margin-bottom: 4px; margin-right: 5px"
                      /></span>
                      <span>Delete</span>
                    </a>
                  </div>
                </div>
              </div>

              <a
                (click)="actionMenuOpen($event)"
                class="mcd-more-btn show-sm"
                [matMenuTriggerFor]="menu"
                href="javascript:void(0);"
              >
                <i class="material-icons">more_vert</i>
              </a>
              <mat-menu #menu="matMenu" overlapTrigger="false">
                <span>
                  <button mat-menu-item (click)="onEdit(item)">Edit</button>
                  <button
                    mat-menu-item
                    (click)="closeMatMenuAndOpenDeleteModal(item, $event)"
                  >
                    Remove
                  </button>
                </span>
              </mat-menu>
            </td>
            <ng-template #exceptionActions>
              <td class="actions-cell"></td>
            </ng-template>
          </tr>
        </tbody>
      </table>

      <div class="listing-table-footer" *ngIf="currentResultCount > 0">
        <div>
          <div>
            <mat-form-field>
              <mat-select
                style="
                  padding: 8px 16px;
                  border: 1px solid #dde1e6;
                  border-radius: 4px;
                  background: #f8fafb;
                "
                [value]="pageSize"
                name="nOfRows"
                #items
                (selectionChange)="selectedItemsPerPageChange(items)"
              >
                <mat-option [value]="item.value" *ngFor="let item of pageSizes">
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div>
          <div>
            <ngb-pagination
              class="float-right"
              [(page)]="page"
              [pageSize]="pageSize"
              [maxSize]="4"
              [rotate]="true"
              [ellipses]="true"
              [collectionSize]="collectionSize"
              (pageChange)="refreshCurrentTabResults()"
            ></ngb-pagination>
          </div>
        </div>

        <div style="display: flex; gap: 10px">
          <button
            class="prevButton"
            [ngStyle]="{
              border: page == 1 ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == 1 ? '#696F77' : '#34393f',
            }"
            (click)="goToPreviousPage()"
          >
            <img src="/assets/images/leftarrow.svg" />
            Previous
          </button>
          <button
            class="nextButton"
            [ngStyle]="{
              border:
                page == totalPages ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == totalPages ? '#696F77' : '#34393f',
            }"
            (click)="goToNextPage()"
          >
            Next
            <img src="/assets/images/rightarrow.svg" />
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="currentResultCount == 0 && !query" class="noResults">
      Sorry you do not have any standard.
    </div>

    <div *ngIf="currentResultCount == 0 && query" class="search-empty-state">
      <img
        src="/assets/images/GRBES-List.svg"
        alt=""
        class="search-empty-icon"
      />
      <h4 class="search-empty-title">No results found</h4>
      <p class="search-empty-subtitle">
        Try a different keyword or refine your search to find what you're
        looking for.
      </p>
    </div>
  </mat-card-content>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>
